import { render, staticRenderFns } from "./HomeDanger.vue?vue&type=template&id=60e94e75&scoped=true"
import script from "./HomeDanger.vue?vue&type=script&lang=js"
export * from "./HomeDanger.vue?vue&type=script&lang=js"
import style0 from "./HomeDanger.vue?vue&type=style&index=0&id=60e94e75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e94e75",
  null
  
)

export default component.exports